import React, { Fragment, useImperativeHandle, useRef, useState } from "react";
import { toast } from "react-toastify";
import commonNetwork from "../../common/api/commonNetwork";
import { Button } from "./Elements";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import Loading from "./Loading";
import { Dialog, Transition } from "@headlessui/react";

type Props={
    isLoading: boolean,
     setIsLoading: (isLoading: boolean)=>void
}
const PaymentSlipModal = React.forwardRef(({isLoading, setIsLoading}: Props, ref) => {

    const [isVisible, setIsVisible] = useState(false);
    const [slipUrl, setSlipUrl] = useState("");
    const [downloadSlipUrl, setDownloadSlipUrl] = useState("");

    useImperativeHandle(ref, () => ({

        showPaymentSlip({ orderId }) {

            selectPaymentSlipUrl(orderId);
        },
        downloadPaymentSlip({ orderId, orderCode }) {

            downloadPaymentSlip(orderId, orderCode);
        },
    }));

    const selectPaymentSlipUrl = async (orderId) => {

        setIsLoading(true);
        const params = {
            orderId: orderId
        }
        const { isSuccess, data, errorMessage } = await commonNetwork.get("/payment/selectPaymentSlipUrl", params);

        setTimeout(() => {
            setIsLoading(false);
        }, 250);
        if (isSuccess) {
            const { downloadurl, innerhtmlurl } = data;


            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

            const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
            const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

            const w = 826;
            const h = 1066;
            const systemZoom = width / window.screen.availWidth;
            const left = (width - w) / 2 / systemZoom + dualScreenLeft
            const top = (height - h) / 2 / systemZoom + dualScreenTop
            var win = window.open("about:blank",
                'popUpWindow',
                `      width=${w / systemZoom},
height=${h / systemZoom},
top=${top},
left=${left},resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes`);
            win.document.write(`<iframe width="100%" height="800" src="${innerhtmlurl}" frameborder="0" allowfullscreen></iframe>`)

        } else {
            toast.error(errorMessage);
        }
        setIsLoading(false);
    }

    const downloadPaymentSlip = async (orderId, orderCode) => {

        setIsLoading(true);
        const params = {
            orderId: orderId
        }
        const { isSuccess, data, errorMessage } = await commonNetwork.get("/payment/selectPaymentSlipUrl", params);
        const { downloadurl, innerhtmlurl } = data;

        fetch(downloadurl).then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);

                const nowDate = new Date();
                const datestr =orderCode + "_Ödeme Dekontu";
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = datestr + '.pdf';
                alink.click();
                setIsLoading(false);
            }).catch(()=> setIsLoading(false))
        }).catch(()=> setIsLoading(false))
    }


    const onDownloadClick = () => {

        window.open(downloadSlipUrl, "_blank");
    }


    return (
        <Modal openModal={isVisible} setOpenModal={setIsVisible} >
            <div>

                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">

                    <div className="mt-4">
                        <div className="max-w-full  min-h-full ">
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <div className="mt-5 mt-4 sm:flex justify-end space-x-2   ">
                                    <Button
                                        color="gray"
                                        hover="gray"
                                        size="xs"
                                        className="mr-12 mt-6"
                                        callback={() => setIsVisible(false)}
                                    >
                                        {"Kapat"}
                                    </Button>

                                    <Button
                                        color="gray"
                                        hover="gray"
                                        size="xs"
                                        className="mr-12 mt-6"
                                        callback={() => onDownloadClick()}
                                    >
                                        {"İndir"}
                                    </Button>

                                </div>
                                <div className=" items-center p-5 rounded-t border-b dark:border-gray-600" style={{ height: '90vh' }}>
                                    {isLoading ? (
                                        <Loading></Loading>
                                    ) : (

                                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                                            <Viewer

                                                fileUrl={slipUrl}
                                            />
                                        </Worker>

                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </Modal>
    );
})
export default PaymentSlipModal;



function Modal({ openModal, setOpenModal, children, containerclass }) {

    const cancelButtonRef = useRef(null);

    return (
        <Transition.Root show={openModal || false} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setOpenModal}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>
                <div className={"fixed z-10 inset-0 overflow-y-auto "}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <Dialog.Panel className="">
                            {children}
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
